<template>
  <div class="list-page-container">
    <div class="breadcrumbs">关于我们</div>
    <div class="list-page-wrap">
      <!-- 列表数据 -->
      <div class="list-page-table">
        <el-form ref="addCompanyForm" :model="addCompanyData" label-position="top">
          <el-form-item label="公司图片" prop="image">
            <el-upload class="avatar-uploader" drag :show-file-list="false" :action="uploadUrl"
              :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
              <img v-if="addCompanyData.image" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司简介">
            <el-input type="textarea" v-model="addCompanyData.description" placeholder="请输入公司简介" rows="4"
              style="border-radius: 4px;"></el-input>
          </el-form-item>
          <el-form-item label="企业优势">
            <!-- 拖拽列表容器 -->
            <div ref="advantageList" class="advantage-list">
              <div v-for="(item, index) in addCompanyData.advantages" :key="index" class="advantage-item"
                :data-id="item.id">
                <el-row :gutter="24">
                  <el-col :span="10">
                    <el-input v-model="item.title" placeholder="请输入企业优势标题" style="border-radius: 4px;"></el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-input v-model="item.content" placeholder="请输入企业优势内容" style="border-radius: 4px;"></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" icon="el-icon-delete" class="advantage-del"
                      @click="removeAdvantage(index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>

            <!-- 添加新优势 -->
            <div class="add-advantage-row">
              <el-row :gutter="24">
                <el-col :span="10">
                  <el-input v-model="newAdvantage.title" placeholder="请输入企业优势标题" style="border-radius: 4px;"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-input v-model="newAdvantage.content" placeholder="请输入企业优势内容"
                    style="border-radius: 4px;"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="addAdvantage" class="advantage-add">+ 添加</el-button>
                </el-col>
              </el-row>
            </div>
            <!-- 保存按钮 -->
            <div class="text-right">
              <el-button type="success" @click="addAdvantageSubmit()">保存修改</el-button>
            </div>
          </el-form-item>
          <el-form-item label="联系方式" class="contact-form-item">
            <el-row :gutter="20">
              <el-col :span="12">
                <span>联系座机</span>
              </el-col>
              <el-col :span="12">
                <span>联系手机</span>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.tel" placeholder="请输入联系座机" style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.mobile" placeholder="请输入联系手机" style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <span>公司地址</span>
              </el-col>
              <el-col :span="6">
                <span>公司经度</span>
              </el-col>
              <el-col :span="6">
                <span>公司纬度</span>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.address" placeholder="请输入公司地址" style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="6">
                <el-input v-model="addCompanyData.coordinates[0]" placeholder="请输入公司经度"
                  style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="6">
                <el-input v-model="addCompanyData.coordinates[1]" placeholder="请输入公司纬度"
                  style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <span>工作时间</span>
              </el-col>
              <el-col :span="12">
                <span>客服在线时间</span>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.working_hours" placeholder="请输入工作时间"
                  style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.customer_service_online_info" placeholder="请输入客服在线时间"
                  style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <span>联系邮箱</span>
              </el-col>
              <el-col :span="12">
                <span>版权信息</span>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.email" placeholder="请输入联系邮箱" style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="addCompanyData.copyright" label="版权信息" placeholder="请输入版权信息"
                  style="border-radius: 4px;"></el-input>
              </el-col>
              <el-col :span="24" class="text-right">
                <el-button type="success" @click="addCompanySubmit()">保存修改</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/api'
// import listMixin from '@/mixins/listMixin'
// import CustomTable from '@/components/custom-table.vue'
import * as DICT from '@/utils/dict/fieldDictionary'
import Sortable from 'sortablejs'

export default {
  name: 'Company',
  // mixins: [listMixin],
  data() {
    return {
      dataDict: DICT,
      sortable: null, // Sortable 实例
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`,
      imageUrl: '',
      addCompanyData: {
        description: '',
        tel: '',
        mobile: '',
        email: '',
        address: '',
        coordinates: ['', ''],
        working_hours: '',
        customer_service_online_info: '',
        image: '',
        image_thumb: '',
        copyright: '',
        advantages: []
      },
      newAdvantage: {
        title: '',
        content: ''
      }
    }
  },
  mounted() {
    this.queryCompany()
    this.initSortable()
  },
  beforeDestroy() {
    // 销毁 Sortable 实例
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    queryCompany() {
      console.log('获取数据')
      const request = {
        ...apis.QUERY_ABOUT
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.addCompanyData = resp.data
              this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${resp.data.image}`
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    handleImageSuccess(res, file) {
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${res.data.id}`
      this.addCompanyData.image = res.data.id
      this.updateCompanyImage()
    },
    beforeImageUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isImg) {
        this.$message.error('只能上传图片格式!')
      }
      return isImg
    },
    updateCompanyImage() {
      const request = {
        ...apis.PUT_ABOUT_IMAGES,
        params: {
          oss_id: this.addCompanyData.image
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    initSortable() {
      let that = this
      const el = this.$refs.advantageList
      this.sortable = new Sortable(el, {
        animation: 150, // 动画时间
        ghostClass: 'sortable-ghost', // 拖拽时的占位符样式
        onEnd: function (evt) {
          // 获取排序之后的data数据
          that.addCompanyData.advantages.splice(evt.newIndex, 0, that.addCompanyData.advantages.splice(evt.oldIndex, 1)[0])
          let newArray = that.addCompanyData.advantages.slice(0)
          that.addCompanyData.advantages = []
          that.$nextTick(function () {
            that.addCompanyData.advantages = newArray
            console.log(that.addCompanyData.advantages)
          })
        }
      })
    },
    // 添加新优势
    addAdvantage() {
      if (!this.newAdvantage.title || !this.newAdvantage.content) {
        this.$message.warning('请输入完整的优势信息')
        return
      }

      // 添加新项
      this.addCompanyData.advantages.push({
        id: Date.now(), // 用时间戳作为唯一ID
        title: this.newAdvantage.title,
        content: this.newAdvantage.content
      })

      // 清空输入框
      this.newAdvantage.title = ''
      this.newAdvantage.content = ''
    },

    // 删除优势
    removeAdvantage(index) {
      this.addCompanyData.advantages.splice(index, 1)
    },
    // 保存修改
    addAdvantageSubmit() {
      // 这里是保存逻辑
      console.log('保存的优势数据：')
      let arr = []
      this.addCompanyData.advantages.forEach((item, index) => {
        item.index = index
        arr.push(item)
      })
      console.log(arr)
      const request = {
        ...apis.PUT_ABOUT_ADVANTAGES,
        params: {
          advantages: arr
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.$message.success('保存成功')
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    addCompanySubmit() {
      this.$refs.addCompanyForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.addCompanyData.coordinates[0] = parseFloat(this.addCompanyData.coordinates[0])
        this.addCompanyData.coordinates[1] = parseFloat(this.addCompanyData.coordinates[1])
        const request = {
          ...apis.PUT_ABOUT,
          params: {
            ...this.addCompanyData
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.$message.success('保存成功')
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    }
  }
}
</script>

<style scoped>
.list-page-table {
  overflow-y: scroll;
}

::v-deep .el-form-item__label {
  font-size: 18px;
}

.avatar-uploader .el-upload {
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.el-upload-dragger {
  width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  /* width: 178px;
    height: 178px;
  display: block;*/
  max-width: 100%;
  height: 100%;
}

.advantage-item .add-advantage-row {
  .el-col {
    margin-bottom: 10px;
  }
}

.advantage-del {
  width: 120px;
  color: #f56c6c;
  font-size: 15px;
}

.advantage-add {
  width: 120px;
  color: #32B768;
}
</style>
